<template lang="pug">
div.modal-bg(@click="closeModal")
    div.select_visit_count_modal(@click.stop)
        div.title
          p.mb-0 訪問履歴指定
          span#modal-close(@click="closeModal") ×
        div.content
          div.visit-type-selection
            .form-check.mb-3
              input.form-check-input(
                type="radio"
                name="visitType"
                id="newVisitor"
                value="new"
                v-model="selectedVisitType"
              )
              label.form-check-label(for="newVisitor") 新規訪問者のみ
            .form-check.mb-3
              input.form-check-input(
                type="radio"
                name="visitType"
                id="repeatVisitor"
                value="repeat"
                v-model="selectedVisitType"
              )
              label.form-check-label(for="repeatVisitor") リピート訪問者のみ
        div.button-group
          button.btn.btn-secondary(@click="resetVisitCount") リセット
          button.btn.btn-success(@click="setVisitCount") セット
</template>

<script>
export default {
  props: {
    initialVisitType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      selectedVisitType: ''
    }
  },
  mounted() {
    // 初期値を設定
    this.selectedVisitType = this.initialVisitType;
  },
  methods: {
    closeModal() {
      this.$emit('close-modal');
    },
    resetVisitCount() {
      this.selectedVisitType = '';
    },
    setVisitCount() {
      this.$emit('data-from-select-visit-count', {
        visitType: this.selectedVisitType
      });
      this.closeModal();
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.select_visit_count_modal {
  background: white;
  border-radius: 8px;
  padding: 20px;
  max-width: 400px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;
}

.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;

  p {
    font-size: 18px;
    font-weight: bold;
  }

  #modal-close {
    cursor: pointer;
    font-size: 24px;
    font-weight: bold;
    color: #999;

    &:hover {
      color: #333;
    }
  }
}

.content {
  margin-bottom: 20px;
}

.visit-type-selection {
  padding: 10px 0;
}

.form-check {
  display: flex;
  align-items: center;

  .form-check-input {
    margin-right: 10px;
  }

  .form-check-label {
    font-size: 16px;
    margin-bottom: 0;
    cursor: pointer;
  }
}

.button-group {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>
